import React from "react";
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  EditButton,
  TextInput,
  
  Filter
} from "react-admin";
import CheckboxInput from "../../inputs/CheckboxInput";
import Icon from "@material-ui/icons/LocalTaxi";
import YesNoField from "../../fields/YesNoField";

export const ClientIcon = Icon;

const ClientFilter = props => (
  <Filter {...props}>
    <TextInput
      elStyle={{ width: 380 }}
      label="resources.misc.fields.name"
      source="name"
    />
    <CheckboxInput
      label="resources.misc.fields.active"
      source="active"
      options={{ defaultToggled: true }}
    />
  </Filter>
);

export const ClientList = props => (
  <List {...props} exporter={false} filters={<ClientFilter />}  bulkActionButtons={false}>
    <Datagrid>
      <TextField source="id" />
      <TextField source="name" />
      <YesNoField source="active" />
      <EditButton basePath="/clients" />
    </Datagrid>
  </List>
);

const ClientTitle = ({ record }) => {
  return <span>Client {record ? `"${record.license}"` : ""}</span>;
};

export const ClientEdit = props => (
  <Edit title={<ClientTitle />} {...props}>
    <SimpleForm>
      <TextInput source="name" />
      <CheckboxInput source="active" />
    </SimpleForm>
  </Edit>
);

export const ClientCreate = props => (
  <Create title="Nov odjemalec" {...props}>
    <SimpleForm redirect="list">
      <TextInput source="name" />
    </SimpleForm>
  </Create>
);
